
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
        current: 0,
    };
  },
  methods: {
    toItem(item, i) {
        if(this.current == i) return;
        this.current = i;
        if(item.path) return this.$router.push({ path: item.path });
        this.$emit('changeLink', item);
    }
  }
};
